import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于 JavBus 平台使用的最常见问题，快速找到答案
          </p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden cursor-pointer"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-50 transition-colors"
              >
                <span className="font-medium text-foreground-900 text-sm pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="/category/faq"
            className="inline-flex items-center text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看更多问题解答
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}